import React, { useState, useCallback, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors';
import { WebFormModel, WebFormStatus } from '../../models/web-form.model';
import { LoadCustomAttributeDefinitions, LoadWebForms } from '../../actions';
import { useDispatch } from 'react-redux';
import { setBackHandler, setHeaderTitle, setRefreshHandler } from '../../helpers/header.helper';
import PageHeaderComponent from '../shared/page-header.component';
import { GridApi, ColumnApi, ColDef, ValueGetterParams, ICellRendererParams } from '@ag-grid-community';
import GridComponent from '../shared/grid';
import { ActionLabels, appNote, buttonLabels, emptyLabels, GridStatusLabelVariant, pageTitles, ToasterTexts } from '../shared/constants';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { CancelIcon, EditIcon, InfoCircleIcon, StartIcon, StopIcon, TransactionHistoryIcon, TrashIcon } from '../../icon';
import WebFormViewComponent from './webform-view.component';
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { WebFormService } from '../../services/WebFormService';
import { UtilityService } from '../../services/UtilityService';
import { dateComparator } from '../shared/grid/grid.services';
import { Dialog, DialogActions, DialogTitle, Tabs, TextField, Tooltip } from '@mui/material';
import Config from '../../config';
import QRCode from 'qrcode.react';
import ButtonComponent from '../shared/button/button.component';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../routes/route.path';
import Confirm_Dialog from '../shared/confirm-dialog.component';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { CustomAttributeDefinitionModel } from '../../models/custom-attribute.model';

const WebForm = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const qrRef = useRef(null);

    const WebForms: WebFormModel[] = useSelector(selector.WebForms)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const IsTeammsApp: boolean = useSelector(selector.isTeamsApp)
    const CustomAttributeFields: CustomAttributeDefinitionModel[] = useSelector(selector.customAttributeFields);

    const [columnApi, setColumnApi] = useState<ColumnApi>(null);
    const [gridApi, setGridApi] = useState<GridApi>(null);
    const [showWebForm, setShowWebForm] = useState<boolean>(false)
    const [selectedWebForm, setSelectedWebForm] = useState<WebFormModel>()
    const [showShareFormLink, setShowShareFormLink] = useState<boolean>(false)
    const [selectedForm, setSelectedForm] = useState<WebFormModel>()
    const [tabvlaue, setTabValue] = useState<string>("Link")
    const [isUrlCopied, setIsUrlCopied] = useState<boolean>(false)
    const [text, setText] = useState<string>("")
    const [buttonLabel, setButtonLabel] = useState<string>("")
    const [confirmTitle, setConfirmTitle] = useState<string>("")
    const [isdelete, setIsDelete] = useState<boolean>(false)
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false)
    const [isloading, setIsLoading] = useState<boolean>(false)
    const WebFormColoumnDefs: ColDef[] = [
        {
            field: "Title",
            headerName: "Title",
            valueGetter: (params: ValueGetterParams) => {
                return params?.data?.Title;
            },
            wrapText: true,
            autoHeight: true,
        },
        {
            field: "Status",
            headerName: "Status",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Status === WebFormStatus.Published ? "Published" : params.data.Status === WebFormStatus.Draft ? "Draft" : params.data.Status === WebFormStatus.Paused ? "Paused" : "Published";
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.Status === WebFormStatus.Published ? "Published" : params.data.Status === WebFormStatus.Draft ? "Draft" : params.data.Status === WebFormStatus.Paused ? "Paused" : "Published";

                    const variant = params.data.Status === WebFormStatus.Paused ? GridStatusLabelVariant.Warning : params.data.Status === WebFormStatus.Published ? GridStatusLabelVariant.Active : GridStatusLabelVariant.Inactive;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
                return undefined
            },
        },
        {
            field: "SelectedGroups",
            headerName: "Groups",
            valueGetter: (params: ValueGetterParams) => {
                return params?.data?.SelectedGroups?.map(x => x.GroupName)?.join(", ")
            },
            wrapText: true,
            autoHeight: true,
        },
        {
            field: "SubmissionsCount",
            headerName: "Submissions",
            valueGetter: (params: ValueGetterParams) => {
                return params?.data?.SubmissionsCount
            },
            wrapText: true,
            autoHeight: true,
        },
        {
            field: "CreatedDateTime",
            headerName: "Updated Date",
            valueGetter: (params: ValueGetterParams) => UtilityService.convertDateToDay(params.data.CreatedDateTime).toString(),
            sort: !IsMobileDevice ? 'desc' : null,
            hide: IsMobileDevice,
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
            minWidth: 150,
            width: 150,
            maxWidth: 150,
            suppressSizeToFit: true
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params => <ActionsRenderer MenuData={getMenuActions(params.data)}
                {...params}
            />,
            resizable: false,
            sortable: false,
            hide: IsMobileDevice
        },
    ]

    const getMenuActions = (data: WebFormModel) => {
        return [
            {
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: () => { openWebForm(data) },
            },
            {
                Name: data.Status === WebFormStatus.Draft ? "Publish" : data.Status === WebFormStatus.Paused ? "Start" : "Stop",
                Icon: StopIcon,
                OnClick: () => { openConfirmation(data, appNote.WEB_FORM_PUBLISH, buttonLabels.PUBLISH, false) },
                Hide: data.Status !== WebFormStatus.Draft,
            },
            {
                Name: data.Status === WebFormStatus.Paused ? "Start" : "Stop",
                Icon: data.Status === WebFormStatus.Paused ? StartIcon : StopIcon,
                OnClick: () => {
                    const isPaused = data.Status === WebFormStatus.Paused;
                    openConfirmation(data, isPaused ? appNote.WEB_FORM_START : appNote.WEB_FORM_STOP, isPaused ? buttonLabels.START : buttonLabels.STOP, false)
                },
                Hide: data.Status === WebFormStatus.Draft,
            },
            {
                Name: "Share Form",
                Icon: EditIcon,
                OnClick: () => { openShowShareFormLinks(data) },
            },
            {
                Name: "Form History",
                Icon: TransactionHistoryIcon,
                OnClick: () => { navigate({ pathname: AppRoutes.WEB_FORM_HISTORY.replace(':formId', data.Id), }) },
            },
            {
                Name: ActionLabels.DELETE,
                Icon: TrashIcon,
                OnClick: () => { openConfirmation(data, appNote.WEB_FORM_DELETE, buttonLabels.DELETE, true); }
            }]
    }

    useEffect(() => {
        if (WebForms?.length === 0) {
            LoadWebForms(dispatch)
        }
        if (CustomAttributeFields?.length === 0) {
            LoadCustomAttributeDefinitions(dispatch)
        }
        setHeaderTitle(pageTitles.WEBFORM)
        setRefreshHandler(gridRefresh)
        return setHeaderTitle
    }, [])

    const closeShowWebForm = useCallback(() => {
        setShowWebForm(false)
        setSelectedWebForm(undefined)
    }, [])

    useEffect(() => {
        setBackHandler(() => {
            if (showWebForm) {
                closeShowWebForm()
            } else {
                navigate(AppRoutes.INTEGRATIIONS)
            }
        })
    }, [showWebForm])

    const openConfirmation = (data: WebFormModel, text: string, buttonLabel: string, isDelete?: boolean) => {
        setSelectedForm(data)
        setText(text)
        setButtonLabel(buttonLabel)
        setIsDelete(isDelete)
        setShowConfirmation(true)
    }

    const closeConfirmation = (isConfirm: boolean) => {
        if (isConfirm) {
            if (isdelete) {
                deleteWebForm(selectedForm)
            } else {
                updateStatus(selectedForm)
            }
        } else {
            clearConfirmInfo()
        }
    }

    const clearConfirmInfo = () => {
        setSelectedForm(undefined)
        setText("")
        setButtonLabel("")
        setIsDelete(false)
        setShowConfirmation(false)
        setIsLoading(false)
    }

    const openShowShareFormLinks = (data: WebFormModel) => {
        setSelectedForm(data)
        setShowShareFormLink(true)
    }

    const closeShowShareFormLinks = () => {
        setShowShareFormLink(false)
        setSelectedForm(undefined)
        setTabValue("Link")
        setIsUrlCopied(false)
    }

    const searchWebForm = (e: any) => {
        gridApi.setQuickFilter(e.target.value);
    }

    const onGridReady = (params) => {
        setGridApi(params.api);
        setColumnApi(params.columnApi)
    }

    const gridRefresh = () => {
        LoadWebForms(dispatch)
    }

    const openWebForm = (data?: WebFormModel) => {
        setSelectedWebForm(data)
        setShowWebForm(true)
    }

    const deleteWebForm = (data: WebFormModel) => {
        setIsLoading(true)
        WebFormService.deleteWebForm(data.Id).then((res) => {
            clearConfirmInfo()
            setToast(ToasterTexts.WEBFORM_DELETE_SUCCESS.replace('<Name>', data.Title), ToasterType.SUCCESS)
        }).catch((err) => {
            clearConfirmInfo()
        })
    }

    const updateStatus = (data: WebFormModel) => {
        setIsLoading(true)
        const status = data.Status === WebFormStatus.Draft ? WebFormStatus.Published : data.Status === WebFormStatus.Paused ? WebFormStatus.Published : WebFormStatus.Paused;
        WebFormService.updateWebformStatus(data.Id, status).then((res) => {
            setToast(ToasterTexts.WEBFORM_EDIT_SUCCESS.replace('<Name>', data.Title), ToasterType.SUCCESS)
            clearConfirmInfo()
        }).catch((err) => {
            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
            clearConfirmInfo()
        })
    }

    const downloadQR = () => {
        const canvas = qrRef.current.querySelector("canvas");
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");

        const downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = "Web-Form-qrcode.png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    const copyUrl = () => {
        const url = `${Config.APP_FE_URL}/webform?formId=${selectedForm.Id}`
        setIsUrlCopied(true)
        if (IsTeammsApp) {
            UtilityService.copyTextFromTeams(url)
        } else {
            navigator.clipboard.writeText(url);
        }
    }

    const copyEmbedUrl = () => {
        const url = `<script src="${Config.WEBFORM_SCRIPT_FILE_LINK}?url=${Config.APP_FE_URL}/webform?formId=${selectedForm.Id}"></script>`
        setIsUrlCopied(true)
        if (IsTeammsApp) {
            UtilityService.copyTextFromTeams(url)
        } else {
            navigator.clipboard.writeText(url);
        }
    }

    return (<>
        {!showWebForm ?
            <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                <PageHeaderComponent
                    onSearch={searchWebForm}
                    Count={WebForms.length}
                    PlaceHolder={"Find a Web form ..."}
                    Actions={[{
                        OnClick: () => { openWebForm() },
                        ButtonLabel: buttonLabels.CREATE_WEBFORM,
                        Variant: "primary-btn",
                    }
                    ]}
                />
                <GridComponent
                    ColumnDefs={WebFormColoumnDefs}
                    RowData={WebForms}
                    OnGridReady={onGridReady}
                    IsPaginationEnabled={!IsMobileDevice}
                    EmptyLabel={emptyLabels.WEBFORMS}
                    LockVisible={IsMobileDevice}
                    gridApi={gridApi}
                />
            </div>
            :
            <WebFormViewComponent WebForm={selectedWebForm} onClose={closeShowWebForm} />
        }

        {
            showConfirmation && (
                <Confirm_Dialog
                    onClose={closeConfirmation}
                    Show={showConfirmation}
                    Text={text}
                    ButtonName={buttonLabel}
                    IsMobileDevice={IsMobileDevice}
                    Loading={isloading}
                />
            )
        }

        {
            showShareFormLink &&
            <Dialog
                onClose={() => closeShowShareFormLinks()}
                aria-labelledby="responsive-dialog-title"
                open={showShareFormLink}
                BackdropProps={IsMobileDevice ? {} : {
                    style: { backgroundColor: "transparent" },
                }}
                className={`${IsDarkMode ? "" : "dialogue-shadow"}  h-p-100`}
                classes={{ paper: `w-70 br-2 ${IsDarkMode ? "" : "dialogue-shadow"}` }}
            >
                <DialogTitle className={`p-2 ${IsDarkMode ? "bg-color-sidebar-bg" : ""}`}>
                    <div className={`${IsMobileDevice ? 'h1' : 'h2-regular'} ${IsDarkMode ? "" : "color-display-title"} d-flex ml-1`} id="customized-dialog-title">
                        {"Share Web Form"}
                        <Tooltip title="Close" placement="bottom">
                            <span className="ml-auto mr-1">
                                <CancelIcon
                                    className={"c-pointer"}
                                    onClick={() => closeShowShareFormLinks()}
                                />
                            </span>
                        </Tooltip>
                    </div>
                </DialogTitle>
                <div className={"bb-primary-background-pink-4 mx-2"}></div>
                <div className={`d-flex p-2 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"}`}>
                    {["Link", "Embed", "QR code"].map((tab, index) => (
                        <div className='w-15 c-pointer' onClick={() => { setTabValue(tab); setIsUrlCopied(false) }} key={index}>
                            <div className='h4-regular color-account-billing-text-gray justify-center d-flex '
                            >{tab}</div>
                            {tab === tabvlaue && <div className='show-conversation-animation  show-conversation-border show-conversation-height bg-color-primary-light'></div>}
                        </div>
                    ))}
                </div>
                <div className={`d-flex p-2 h-20 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"}`}>
                    {
                        tabvlaue === "Link" ?
                            <div className='w-p-100'>
                                <div className='h4-medium'>Form URL</div>
                                <div className='d-flex align-center w-p-100'>
                                    <TextField
                                        size='small'
                                        className='p-0 w-p-80'
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        value={`${Config.APP_FE_URL}/webform?formId=${selectedForm.Id}`}
                                        InputProps={{ classes: { input: `h4-regular color-secure-file-dialog-title` } }}
                                    />
                                    <ButtonComponent ButtonLabel={isUrlCopied ? buttonLabels.COPIED : buttonLabels.COPY} Variant={"secondary-btn"} ClassName='float-right  h5-regular ml-2' OnClick={copyUrl} />
                                </div>
                                <div className='h5-regular'>Share via email, social media, or messaging apps</div>
                                <div className='b-around-consent-message-border color-button-text bg-color-consent-message-bg br-1 py-1 d-flex align-center mt-1'>
                                    <InfoCircleIcon className='mx-1' />
                                    <div className='d-flex flex-direction'>
                                        <span className='h5-medium color-primary-accent'>Make sure your form is Published</span>
                                        <span className='color-primary-light h5-regular'>This link open only work for visitors if the form status is set to Publish</span>
                                    </div>
                                </div>
                            </div> :
                            tabvlaue === "Embed" ? <div className='w-p-100 '>
                                <div className='w-p-90 h5-medium'>Copy and paste the following code into your website to embed the form</div>
                                <div className='d-flex align-center '>
                                    <TextField
                                        size='small'
                                        className='p-0 w-p-80'
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        // value={`<iframe src="${Config.APP_FE_URL}/webform?formId=${selectedForm.Id}" width="100%" height="700px"></iframe>`}
                                        value={`<script src="${Config.WEBFORM_SCRIPT_FILE_LINK}?url=${Config.APP_FE_URL}/webform?formId=${selectedForm.Id}"></script>`}
                                        InputProps={{ classes: { input: `h4-regular color-secure-file-dialog-title` } }}
                                    />
                                    <ButtonComponent ButtonLabel={isUrlCopied ? buttonLabels.COPIED : buttonLabels.COPY} Variant={"secondary-btn"} ClassName='float-right  h5-regular ml-2' OnClick={copyEmbedUrl} />
                                </div>
                                <div className='b-around-consent-message-border color-button-text bg-color-consent-message-bg br-1 py-1 d-flex align-center mt-1'>
                                    <InfoCircleIcon className='mx-1' />
                                    <div className='d-flex flex-direction'>
                                        <span className='h5-medium color-primary-accent'>Make sure your form is Published</span>
                                        <span className='color-primary-light h5-regular'>This link will only work for visitors if the form status is set to Published.</span>
                                    </div>
                                </div>
                            </div> :
                                <div className='w-p-100'>
                                    <div className='d-flex justify-center w-p-100' ref={qrRef}>
                                        <QRCode
                                            value={`${Config.APP_FE_URL}/webform?formId=${selectedForm.Id}`}
                                            size={115}
                                            includeMargin={true}
                                            fgColor={"#013243"}
                                        />
                                    </div>
                                    <div className='t-align-center color-primary-accent h5-regular'>Scan QR code or <span className='color-primary-light c-pointer' onClick={downloadQR}>Download QR </span> and share</div>
                                </div>
                    }
                </div>
                <DialogActions className={`px-2 py-0 ${IsDarkMode ? 'bg-color-sidebar-bg' : 'bg-color-report-background'}`}>
                    <ButtonComponent ButtonLabel={buttonLabels.CANCEL} Variant='secondary-btn' OnClick={() => closeShowShareFormLinks()} />
                </DialogActions>
            </Dialog>
        }
    </>
    )
}

export default WebForm